import { render, staticRenderFns } from "./cancelScoreDialog.vue?vue&type=template&id=20510b99&scoped=true&"
import script from "./cancelScoreDialog.vue?vue&type=script&lang=js&"
export * from "./cancelScoreDialog.vue?vue&type=script&lang=js&"
import style0 from "./cancelScoreDialog.vue?vue&type=style&index=0&id=20510b99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20510b99",
  null
  
)

export default component.exports